import React, { useState, useEffect } from "react";
import { getDeliveryBoyById } from "../../../lib/apiCalls";
import { useParams } from "react-router-dom";
import i18n from "../../../lib/i18n";
import EditDeliveryBoysUi from "../../../ui/deliveryBoysUi/editDeliveryBoysUi";

export default function EditDeliveryBoys() {
  const [deliveryBoyByIdData, setDeliveryBoyByIdData] = useState({});
  const { deliveryBoyId } = useParams();
  const t = i18n.t.bind(i18n);

  useEffect(() => {
    handleApi();
  }, []);

  const handleApi = async () => {
    try {
      const byId = await getDeliveryBoyById(deliveryBoyId);
      setDeliveryBoyByIdData({});
      setDeliveryBoyByIdData(byId.data?.data || {});
    } catch (err) {
      setDeliveryBoyByIdData({});
    }
  };

  return (
    <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
      <div>
        <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">
          {t("edit_page_title.deliveryBoys")}
        </h1>
        <EditDeliveryBoysUi
          deliveryBoyByIdData={deliveryBoyByIdData}
        />
      </div>
    </div>
  );
}
